<a class="notification-link" (click)="downloadFile()">
  {{ 'Analysis::TrendAnalysis:ExportReadyNotificationMessage' | abpLocalization }}
</a>
